export function isLoopbackHostname(hostname: string | null | undefined) {
  const normalized = String(hostname || '').trim().toLowerCase()
  return (
    normalized === '127.0.0.1' ||
    normalized === 'localhost' ||
    normalized === '::1' ||
    normalized === '[::1]' ||
    normalized === '0:0:0:0:0:0:0:1' ||
    normalized === '[0:0:0:0:0:0:0:1]'
  )
}

export function isLoopbackRequestUrl(url: string | URL) {
  try {
    const parsed = typeof url === 'string' ? new URL(url) : url
    return /^https?:$/.test(parsed.protocol) && isLoopbackHostname(parsed.hostname)
  } catch {
    return false
  }
}

export function shouldUseSecureCookieForRequest(request: Request) {
  if (process.env.NODE_ENV !== 'production') {
    return false
  }

  return !isLoopbackRequestUrl(request.url)
}

export function normalizeCookieOptionsForRequest<T extends Record<string, any>>(
  request: Request,
  options: T
): T {
  if (!isLoopbackRequestUrl(request.url)) {
    return options
  }

  return {
    ...options,
    secure: false
  }
}
